

export const SizeFromLeft = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <line x1="1" x2="1" y1="0%" y2="100%" strokeWidth="1.5" stroke="#838280" />
            <rect x="7" y="4" width="11" height="11" stroke="#838280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}